export default "__VITE_ASSET__CMkqD4WR__"